export default function objectToQueryString(obj: {
  [key: string]: string | number | boolean
}): string {
  const items: string[] = []
  Object.entries(obj).forEach(([key, value]) => {
    if (![undefined, null].includes(value)) {
      items.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    }
  })

  return !items.length ? '' : `?${items.join('&')}`
}
